export default __webpack_public_path__ + "static/media/videoConference.7a755c6a.jpg";